module.exports = __webpack_public_path__ + "img/white-logo.511c54bf.png";